import type { ReactNode } from 'react';
import { ROW_EXIT_TRANSITION } from './rowExit';

interface CollapsibleCellProps {
    collapsed: boolean;
    children: ReactNode;
}

// Table rows can't animate height, so each cell's content collapses its grid row (1fr to 0fr) instead.
// Clips only vertically and only while collapsing: sub-rows overflow sideways and the assignee menu pops out.
export function CollapsibleCell({ collapsed, children }: CollapsibleCellProps) {
    return (
        <div
            className={`grid grid-cols-[minmax(0,1fr)] transition-[grid-template-rows,opacity] ${ROW_EXIT_TRANSITION} ${
                collapsed ? 'grid-rows-[0fr] opacity-0' : 'grid-rows-[1fr] opacity-100'
            }`}
        >
            <div className={`min-h-0 min-w-0 ${collapsed ? 'overflow-y-clip' : ''}`}>
                {children}
            </div>
        </div>
    );
}
